
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/transfer-applications",
      function () {
        return require("private-next-pages/admin/transfer-applications/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/transfer-applications"])
      });
    }
  